import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { ClientForm } from "../../interfaces/client-form.interface";

const clientsUrlApi = environment.clientsUrlApi;
const clientsWithFiltersUrlApi = environment.clientsWithFiltersUrlApi;
const blockUnblockUrlApi = environment.blockUnblockClientById;
const clientUserByClient = environment.clientUserByClient;

@Injectable()
export class ClientService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  getClients() {
    return this.http
      .request("GET", `${clientsUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getClientsWithFilter(filters) {
    const params = filters;
    console.log(params);
    return this.http
      .post(`${clientsWithFiltersUrlApi}`, params)
      .pipe(map((resp: any) => resp));
  }

  getClientById(id: number) {
    return this.http
      .request("GET", `${clientsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getClientUserByClientId(id: number) {
    return this.http
      .request("GET", `${clientUserByClient}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateClientById(id: number, clientModel: ClientForm) {
    console.log(id);
    console.log(clientModel);
    delete clientModel.active;
    const body = clientModel;
    return this.http
      .request("PUT", `${clientsUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createClient(clientModel: ClientForm) {
    console.log(clientModel);
    delete clientModel.active;
    /*    clientModel.ciphed_videos =
      clientModel.ciphed_videos == true ? Number(1) : Number(0);
 */
    clientModel.ciphed_videos = Number(0);
    const body = clientModel;
    return this.http
      .request("POST", `${clientsUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  changeStatusClientById(id: number, status: boolean) {
    const body = { active: !status };
    return this.http
      .request("PUT", `${blockUnblockUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteClientById(id: number) {
    return this.http
      .request("DELETE", `${clientsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
}
